<div class="supplementary-equipment-details">
  <div class="options-list">
    <div class="form-box">
      <sc-padding>
        <sc-flex vertical stretchContent>
          @for (se of supplementaryEquipment; track se; let i = $index) {
            @if (i > 0) {
              <sc-content-spacer vertical></sc-content-spacer>
            }
            <sc-flex>
              <sc-checkbox-field [disabled]="true" [label]="se.name"></sc-checkbox-field>
              @if (se.selectedIdentifier != null) {
                <sc-content-spacer></sc-content-spacer>
                <sc-string-field [disabled]="true"
                  [textContent]="se.selectedIdentifier"
                labelDictionaryKey="tmc-common.equipment.entity.equipment.identifier" ></sc-string-field>
              }
            </sc-flex>
          }
        </sc-flex>
      </sc-padding>
    </div>
  </div>
</div>
